import injectScript from './utils/injectScript';
import { getSocialNetwork } from './utils/getSocialNetwork';

import { LoadPayload, WidgetParams } from './types';
import serverVars from 'server-vars';

const APPLE_CLIENT_ID = 'com.1stdibs.1stdibs.client';

const scripts = {
    pinterest(options: WidgetParams) {
        return getSocialNetwork
            .byName('PINTEREST', options.relayEnvironment)
            .then((pinterestApp: $TSFixMe) => {
                if (pinterestApp) {
                    return injectScript('//assets.pinterest.com/sdk/sdk.js').then(() => {
                        // @ts-ignore global.PDK added by pinterest widget
                        return global.PDK;
                    });
                }

                return null;
            });
    },

    facebook(options: WidgetParams) {
        const locale = options.locale || 'en-US';
        const formattedLocale = locale.replace('-', '_'); // locale must be snake_case
        return getSocialNetwork
            .byName('FACEBOOK', options.relayEnvironment)
            .then((fbApp: $TSFixMe) => {
                if (fbApp) {
                    return injectScript(`//connect.facebook.net/${formattedLocale}/sdk.js`, {
                        id: 'facebook-jssdk',
                    }).then(() => {
                        // @ts-ignore global.FB added by FB widget
                        global.FB.init({
                            appId: fbApp.parameters.clientId,
                            autoLogAppEvents: true,
                            xfbml: true,
                            version: 'v3.2',
                        });
                        // @ts-ignore global.FB added by FB widget
                        global.FB.AppEvents.logPageView();

                        // @ts-ignore global.FB added by FB widget
                        return global.FB;
                    });
                }

                return null;
            });
    },

    google(options: WidgetParams) {
        return getSocialNetwork
            .byName('GOOGLE', options.relayEnvironment)
            .then((googleApp: $TSFixMe) => {
                if (googleApp) {
                    return injectScript('//apis.google.com/js/platform.js?onload=init').then(() => {
                        return new Promise(resolve => {
                            window.gapi.load('auth2', () => {
                                const GoogleAuth = window.gapi.auth2.init({
                                    ['client_id']: googleApp.parameters.clientId,
                                });
                                GoogleAuth.then(resolve);
                            });
                        });
                    });
                }
                return null;
            });
    },

    apple(options: WidgetParams) {
        return getSocialNetwork.byName('APPLE', options.relayEnvironment).then(() => {
            return injectScript(
                '//appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
            ).then(() => {
                window.AppleID.auth.init({
                    clientId: APPLE_CLIENT_ID,
                    scope: 'email name',
                    redirectURI: `${serverVars.get('localeOrigin')}/signinwithapple/dibs-post`,
                    state: '',
                    usePopup: true,
                });
            });
        });
    },
};

const cachedLoaders: Record<LoadPayload, Promise<$TSFixMe>> = Object.create(null);

/**
 * Scripts loader. Also it caches loading promise to load script once.
 *
 * @param  {String} type script provider
 * @return {Promise}
 */
const load = function(type: LoadPayload, options: WidgetParams): Promise<$TSFixMe> {
    const loader = cachedLoaders[type];
    if (loader) {
        return loader;
    }

    if (!scripts[type]) {
        throw new Error('Widget script for ' + type + ' is not provided.');
    }

    cachedLoaders[type] = scripts[type](options);

    return cachedLoaders[type];
};

const widgetLoader = {
    load,
    constants: {
        APPLE_CLIENT_ID,
    },
};

export default widgetLoader;
